import React from "react";
import img from "../Assets/foot.png";
import { FaWhatsapp } from "react-icons/fa";
import { CiLinkedin } from "react-icons/ci";
import icon5 from "../Assets/pinterest-round-white-icon.webp";
import 'bootstrap-icons/font/bootstrap-icons.css';
import pin from '../Assets/white-pinterest-logo-png--30.png'
import icon6 from "../Assets/whatsapp_icon.png";
import icon4 from "../Assets/Link-1.png";
import icon2 from "../Assets/Link-2.png";
import icon3 from "../Assets/Link-3.png";
import icon1 from "../Assets/Link.png";
import { Link } from "react-router-dom";
import logo from "../Assets/newlogo-optimized.webp";
import Wave from "./Wave";
function Footer() {
  return (
    <>
      {/* <img className='foot-img' src={img}/> */}
      <Wave />
      <div className="footer">
        <img className="cinelogo2" src={logo} alt="Cine Celebrate logo" />
        <br />
        <br />
        <ul>
          <Link className="none2" to="/" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
            <li>Home</li>
          </Link>

          <Link className="none2" to="/about" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
            <li>About Us</li>
          </Link>

          <Link className="none2" to="/services" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
            <li>Services</li>
          </Link>

          <Link className="none2" to="/booknow" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
            <li>Book Now</li>
          </Link>
          <Link className="none2" to="/faq" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
            <li>FAQ</li>
          </Link>
          <Link className="none2" to="/tnc" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
            <li>Terms and Conditions</li>
          </Link>

          <Link className="none2" to="/policy" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
            <li>Privacy Policy</li>
          </Link>
          <Link className="none2" to="/refund" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
            <li>Refund Policy</li>
          </Link>

          <Link className="none2" to="/contact" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
            <li>Contact Us</li>
          </Link>
        </ul>

        <div className="social">
          <a style={{color:'white'}} href="https://www.facebook.com/share/19u3ZeyUhZ/" target="_blank" rel="noopener noreferrer">
            <i style={{color:'white'}} class="bi bi-facebook"></i>
          </a>
          <a style={{color:'white'}} href="https://www.instagram.com/cinecelebrate_in" target="_blank" rel="noopener noreferrer">
            <i class="bi bi-instagram"></i>
          </a>
          <a style={{color:'white'}} href="https://youtube.com/@cinecelebrate?si=jGadqCXx5Y8ZEvuL" target="_blank" rel="noopener noreferrer">
           <i class="bi bi-youtube"></i>
          </a>
          <a style={{color:'white'}} href="https://x.com/CineCelebrate?t=104PP-8SeNJ7nXPxYuV0dA&s=09" target="_blank" rel="noopener noreferrer">
           <i class="bi bi-twitter"></i>
          </a>
           {/* <a style={{color:'white'}} href="https://pin.it/1pBJY7Gjz" target="_blank" rel="noopener noreferrer">
<img style={{height:'20px'}} src={pin}/>
          </a> */}
          {/* <a href="https://whatsapp.com/channel/0029Vb7EjxHEQIafAEOkOh2j" target="_blank" rel="noopener noreferrer" >
            <FaWhatsapp />
          </a>
          <a href="https://www.linkedin.com/in/cine-celebrate-3a98a2352?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank" rel="noopener noreferrer">
            <CiLinkedin />
          </a> */}
        </div>
      </div>
      <div className="line"></div>
      <div className="bottom-fotter">
        <p>SWASTIK ENTERTAINMENTS © 2024 | India | All Rights Reserved. Designed & Developed by <Link style={{color:'white',textDecoration:'none',fontWeight:'700'}} to='https://strixdigital.in/'>Strix Digital.</Link> </p>
      </div>
    </>
  );
}

export default Footer;
